import * as React from 'react';
import PriceRow from 'components/OfferPriceRow/OfferPriceRow';
import { get } from 'lodash';
import { OfferSymbol } from 'components/PriceSummary/PriceLineItem';
import FormattedMessage from 'components/FormattedMessage/FormattedMessage';
import cx from 'classnames';
import styles from './PopUpPriceInfo.css';
import { PriceType } from '@rome/response/transact/PriceType';
// TODO: The REVERSE check is hardcoded as of now. Move to a switch statement.
function FinalPrice(props) {
    const { finalPrice } = props;
    if (!finalPrice || typeof finalPrice.multiCurrencyPrice === 'undefined') {
        return null;
    }
    let priceRowProps = {
        text: finalPrice.label,
        value: finalPrice.multiCurrencyPrice,
        textClassName: styles['total'],
        valueClassName: styles['total']
    };
    if (finalPrice.priceType === PriceType.REVERSE) {
        Object.assign(priceRowProps, { prefix: OfferSymbol.Minus });
    }
    return (<div className={styles['price-total']}>
			<PriceRow {...priceRowProps}/>
		</div>);
}
export default function PopUpPriceInfo(props) {
    const priceLineItems = get(props, 'details.priceDetails.priceLineItems', []);
    const finalPrice = get(props, 'details.priceDetails.multiCurrencyfinalPrice');
    const { appliedOffers = [] } = props;
    if (!finalPrice && !priceLineItems.length) {
        return null;
    }
    // TODO: Make this another component
    const children = priceLineItems.map((lineItem, index) => {
        let valueClassName = cx({
            [styles['linethrough']]: lineItem.strikeOff === true
        });
        switch (lineItem.priceType) {
            case PriceType.PRICE:
                return <PriceRow text={lineItem.label} value={lineItem.value} key={index} valueClassName={valueClassName}/>;
            case PriceType.DISCOUNT:
                valueClassName = cx(valueClassName, styles['discount-price']);
            // tslint:disable-next-line:no-switch-case-fall-through
            case PriceType.REVERSE:
                return (<PriceRow text={lineItem.label} value={lineItem.value} key={index} valueClassName={valueClassName} prefix={OfferSymbol.Minus}/>);
            case PriceType.COIN_PRICE: {
                const coinPrice = get(lineItem, [
                    'multiCurrencyPrice',
                    'data'
                ]);
                return (<PriceRow text={<FormattedMessage data={coinPrice} imageClass={styles['coin-icon']} imageSize={10}/>} value={lineItem.value} key={index} valueClassName={cx(valueClassName, styles['discount-price'])} prefix={OfferSymbol.Minus}/>);
            }
            default:
                return null;
        }
    });
    const appliedOffersChildren = appliedOffers && appliedOffers.length ? (<React.Fragment>
				{appliedOffers.map((o, idx) => (<PriceRow text={o.promotionMessage} value={o.promotionAmount} valueText={o.promotionAmountText} key={idx} prefix={OfferSymbol.Minus} valueClassName={styles['discount-price']}/>))}
			</React.Fragment>) : null;
    return (<div className={styles['price-details']}>
			{children}
			{appliedOffersChildren}

			<FinalPrice finalPrice={finalPrice}/>
		</div>);
}
